<template>
  <footer
    class="form-fw__footer"
    :class="{ 'form-fw__footer--shadow': shadow }"
  >
    <div class="form-fw__footer__container py-2">
      <div class="text-xs-right">
        <v-btn
          :to="{ name: 'Revenues' }"
          type="submit"
          color="accent"
          depressed
          round
        >
          {{ $t(`${namespace}.return`) }}
        </v-btn>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'RevenuesFooter',
  data () {
    return {
      namespace: 'Views.RevenuesPage',
      shadow: true
    }
  },
  methods: {
    setChatPosition (bottom = null, right = null) {
      const chat = document.querySelector('#oloswcdl-root .oloswebchat-main .cta-button')
      if (chat) {
        chat.style.bottom = bottom
        chat.style.right = right
      }
    },

    setCurrentStatus () {
      this.$emit('setCurrentStatus', null)
      this.setChatPosition('26px', '43px')
    },

    handleShadow () {
      this.shadow = !((window.innerHeight + window.scrollY) >= document.body.offsetHeight)
    }
  },
  watch: {
    status (val) {
      if (val > 1) this.setChatPosition('75px', '43px')
    }
  },
  mounted () {
    this.setChatPosition('26px', '43px')
    this.handleShadow()
    window.addEventListener('scroll', this.handleShadow)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleShadow)
    this.setChatPosition()
  }
}
</script>
